import { render, staticRenderFns } from "./LoginDashboardPlatform.vue?vue&type=template&id=277792fe"
import script from "./LoginDashboardPlatform.vue?vue&type=script&lang=js"
export * from "./LoginDashboardPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports